import { render, staticRenderFns } from "./OrgFooter.vue?vue&type=template&id=6f4b71cb"
import script from "./OrgFooter.vue?vue&type=script&lang=js"
export * from "./OrgFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports